/** Phone and messenger are free text the person typed: links are made only from shapes we can trust. */

/** `tel:` link for a phone the BFF already restricted to digits, +, spaces, brackets and dashes. */
export function phoneHref(phone: string): string | null {
  const digits = phone.replace(/[^\d+]/g, '');
  return /^\+?\d{5,}$/.test(digits) ? `tel:${digits}` : null;
}

/** https://t.me/<handle> for «@handle», «t.me/handle» and «Telegram: @handle»; null for anything else. */
export function messengerHref(messenger: string): string | null {
  const m = messenger.trim().match(/^(?:(?:telegram|телеграм|tg)\s*:\s*)?(?:@|(?:https?:\/\/)?t\.me\/@?)([A-Za-z]\w{3,31})$/i);
  return m ? `https://t.me/${m[1]}` : null;
}
